import { SET_DEALER_GSTN_VERIFY, SET_DEALER_PAN_NSDL_VERIFY, SET_DEALER_MSME_VERIFY, UPDATE_KYC_PAYLOAD } from '../actionTypes'


export const kycInitialState = {
    bank_details_ticket_id: 0,
    kyc_id: 0,
    panCard: { user_pan_card_number: "", user_pan_card_name: "", user_pan_card_image: "", is_pan_verified: "", panNSDLVerify:false },
    gstin: { gstin_state: "", gstin_pincode: "",entity_type: "", gstin_number: "",gstin_number_last_three_digit:"" ,gstin_account_name: "", gstin_image:"", is_gstn_verified: "", gstinVerify:false, tradeName: "" },
    bankDetails: { bank_account_number: "", bank_account_name: "", bank_name: "", ifsc_code: "", cancelled_cheque_number: "", cancelled_cheque_image: "", is_bank_details_verified: "" },
    authorizedSignatory: { signatory_relationship: "", supporting_doc: "", signatory_aadhar_number: "", signatory_aadhar_name: "", signatory_aadhar_image: "", signatory_pan_number: "", signatory_pan_name: "", signatory_pan_image: "", is_signatory_aadhar_verified: "", is_signatory_pan_verified: "" },
    tan: {tan_card_number: "", tan_card_image: ""},
    msme: { msme_certificate_number: "", msme_certificate_image: "", is_msme_verified: false },
}

export default (state = kycInitialState, action) => {
    switch (action.type) {

        case SET_DEALER_PAN_NSDL_VERIFY:
            return {
                ...state,
                panCard: {
                ...state.panCard,
                panNSDLVerify: action.payload,
                },
            };

            case SET_DEALER_GSTN_VERIFY:
                return {
                    ...state,
                    gstin: {
                    ...state.gstin,
                    gstinVerify: action.payload,
                    },
                };
            case SET_DEALER_MSME_VERIFY:
                return {
                    ...state,
                    msme: {
                    ...state.msme,
                    is_msme_verified: action.payload,
                    },
                };
      
        case UPDATE_KYC_PAYLOAD:
            return { ...state, ...action.payload.kyc };


        default: return { ...state };
    }

}